import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';
import { SectionColumnConfigProductInfoKey } from 'src/app/models/enum/shared/section-column-config-product-info-key';
import { BadgeAsset } from 'src/app/models/image/dto/badge-asset';

@Component({
  selector: 'app-column-variant-type',
  templateUrl: './column-variant-type.component.html',
  styleUrls: ['./column-variant-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnVariantTypeComponent extends ColumnComponent {
  getNonListColumnItem(): BadgeAsset | string | undefined {
    if (this.colVm.columnConfigDataValueIsBadgeMode()) {
      return this.rowVm.getBadgeAssetForColumnType(SectionColumnConfigProductInfoKey.VariantType)?.image;
    }
    return this.rowVm.rowVariantType();
  }
}
